import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { SimplePopup, enums } from '@cheetahdigital/console-kit-cx';
import classNames from '../../../node_modules/classnames/index.js';
import styles from './index.module.scss.js';

var Dropdown = function (_a) {
    var trigger = _a.trigger, children = _a.children, isPaddingless = _a.isPaddingless, _b = _a.position, position = _b === void 0 ? "bottom" : _b, isAutoWidth = _a.isAutoWidth, mouseLeaveDelay = _a.mouseLeaveDelay;
    return (jsx(SimplePopup, __assign({ isBasic: true, showOn: "click", hideOnScroll: true, closeOnClick: true, style: { padding: 0, margin: 0 }, position: position ? position : enums.positions.BOTTOM, trigger: trigger, mouseLeaveDelay: mouseLeaveDelay }, { children: jsx("div", __assign({ className: classNames(styles.container, isPaddingless && styles.isPaddingless), style: isAutoWidth ? { width: "auto" } : {} }, { children: children }), void 0) }), void 0));
};

export { Dropdown as default };
